<template>
    <section class="invalid-state" aria-labelledby="invalid-title">
        <header class="invalid-hotel">
            <div class="invalid-hotel-mark" aria-hidden="true">{{ monogram }}</div>
            <div>
                <strong>{{ hotelName }}</strong>
                <small>{{ hotelSubtitle }}</small>
            </div>
        </header>

        <div class="invalid-illustration" aria-hidden="true">
            <span class="invalid-link">⌁</span>
            <span class="invalid-heart">♥</span>
        </div>

        <p class="invalid-eyebrow">{{ $t('invalid.eyebrow') }}</p>
        <h1 id="invalid-title">{{ $t('invalid.title') }}</h1>
        <p class="invalid-lead">{{ $t('invalid.text') }}</p>

        <div class="invalid-help">
            <h2>{{ $t('invalid.help_title') }}</h2>
            <ol>
                <li v-for="step in steps" :key="step.title">
                    <span>{{ step.number }}</span>
                    <div>
                        <strong>{{ $t(step.title) }}</strong>
                        <p>{{ $t(step.text) }}</p>
                    </div>
                </li>
            </ol>
        </div>

        <button class="primary invalid-retry" type="button" @click="reload">
            {{ $t('invalid.retry') }}
        </button>

        <p class="invalid-security">
            <span aria-hidden="true">◆</span>
            {{ $t('invalid.security') }}
        </p>
    </section>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useI18n } from 'vue-i18n'

    import { useAppStore } from '@/stores/app'

    const { t } = useI18n()
    const appStore = useAppStore()

    const hotelName = computed(() =>
        appStore.stay?.property.portal.display_name ||
        appStore.stay?.property.name ||
        t('invalid.hotel_fallback'))

    const hotelSubtitle = computed(() =>
        appStore.stay?.property.portal.tagline || t('invalid.reception'))

    const monogram = computed(() =>
        appStore.stay?.property.portal.monogram ||
        hotelName.value.replace(/^Hotel\s+/i, '').charAt(0).toUpperCase() ||
        'H')

    const steps = [
        { number: 1, title: 'invalid.step_contact_title', text: 'invalid.step_contact_text' },
        { number: 2, title: 'invalid.step_identify_title', text: 'invalid.step_identify_text' },
        { number: 3, title: 'invalid.step_open_title', text: 'invalid.step_open_text' },
    ]

    const reload = () => window.location.reload()
</script>
